import { useEffect } from 'react';
import { useNavigate, useSearch } from '@tanstack/react-router';

export type ImportSearchParams = {
  import?: string;
  tab?: string;
  selected?: string;
};

export type ImportKind = 'agreements' | 'customers' | 'equipment';

/** Deep-link target for spreadsheet import (?import=agreements|customers|equipment|1). */
export function importSpreadsheetSearch(kind: ImportKind = 'agreements') {
  return { import: kind };
}

type ImportAccept = ImportKind | 'generic';

function importMatchesAccept(value: string | undefined, accept: readonly ImportAccept[]): boolean {
  if (!value) return false;
  if (value === '1' || value === 'true') return accept.includes('generic');
  return accept.includes(value as ImportAccept);
}

/** Opens the import modal when ?import= is in the URL, then clears the param. */
export function useImportModalFromSearch(
  setImportOpen: (open: boolean) => void,
  accept: readonly ImportAccept[] = ['agreements', 'customers', 'equipment', 'generic'],
) {
  const search = useSearch({ strict: false }) as ImportSearchParams;
  const navigate = useNavigate();

  useEffect(() => {
    if (!importMatchesAccept(search.import, accept)) return;
    setImportOpen(true);
    navigate({
      search: ((prev: ImportSearchParams) => {
        const next = { ...prev };
        delete next.import;
        return next;
      }) as never,
      replace: true,
    });
  }, [search.import, accept, navigate, setImportOpen]);
}
